<template>
  <svg width="150" height="150" viewBox="0 0 150 150" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M75 150C116.421 150 150 116.421 150 75C150 33.5786 116.421 0 75 0C33.5786 0 0 33.5786 0 75C0 116.421 33.5786 150 75 150Z" fill="#9FD873"/>
    <path d="M115.821 47.0828C115.678 47.9992 115.217 48.8797 114.419 49.5446C95.3955 65.3674 81.4581 86.7032 67.7193 113.102C66.8241 114.821 65.0526 115.912 63.1249 116.109C61.1551 116.311 59.1956 116.66 57.2784 117.156C54.6624 117.829 51.9197 116.677 50.5706 114.337C45.0662 104.813 37.8451 96.2803 29.3573 89.281C28.0757 88.2253 27.8034 86.3798 28.7176 84.9949C28.7514 84.94 28.7872 84.8873 28.8231 84.8323C33.6921 77.548 44.2702 77.244 49.5719 84.22C52.1838 87.6531 54.8779 91.1454 57.3102 95.0769C69.4951 75.8715 89.5237 53.0263 110.061 42.8641C111.225 42.2878 112.597 42.3025 113.746 42.9147C115.346 43.77 116.068 45.4801 115.821 47.0828Z" fill="#329B4B"/>
  </svg>
</template>

<script>

export default {};
</script>
